import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media only screen and (min-width: 769px) {
    width: 1016px;
    margin-bottom: 40px;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;
  border-radius: 24px;
  @media only screen and (min-width: 769px) {
    gap: 16px;
  }
`;

export const TextContainer = styled.div`
  text-align: center;
  padding: 12px;
  border-radius: 24px;
`;

export const Title = styled.p`
  margin: 0px 0px 8px 0px;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  align-self: center;

  @media only screen and (min-width: 769px) {
    margin: 0px 0px 24px 0px;
    font-size: 32px;
    line-height: 40px;
  }
`;

export const ImageContainer = styled.div`
  background: transparent;
  border-radius: 24px;
  width: 301px;
  height: 180px;
  display: flex;
  justify-content: center;
  cursor: ${(props) => props?.cursor ?? "default"};

  @media only screen and (min-width: 769px) {
    display: flex;
    justify-content: center;
    height: auto;
    min-height: 112px;
  }
`;
